module.exports = __webpack_public_path__ + "img/icon-centros.82f06626.svg";